import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import clear from "../../../shared/images/close.svg";

const SearchBC = (props) => {
  const [bowlingcentersFiltered, setBowlingcentersFiltered] = useState([]);
  const [criteria, setCriteria] = useState("");
  const [showClearBtn, setShowClearBtn] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const dirty = useRef(false);

  useEffect(() => {
    setCriteria(
      (props.bowlingCenterInput &&
        props.bowlingCenterInput.bowlingCenterName) ||
        ""
    );
  }, [props.bowlingCenterInput]);

  useEffect(() => {
    if (dirty.current) {
      setBowlingcentersFiltered(
        props.bowlingCentersList.filter((b) =>
          b.companyName.toLowerCase().includes(criteria.toLowerCase())
        )
      );
      setLoading(false);
    }
  }, [criteria, props.bowlingCentersList]);

  const handleOnChange = (e) => {
    if (!dirty.current) dirty.current = true;
    // set input value in state
    setCriteria(e.target.value);
    if (e.target.value.length > 0) {
      // show/hide clear btn
      setShowClearBtn(true);
      // set loading state
      setLoading(true);
    } else {
      setShowClearBtn(false);
      setLoading(false);
      dirty.current = false;
    }
    props.handleChange(props.index, "bowlingCenterName")(e);
    props.handleChange(props.index, "uuid")(e);
  };

  const handleClear = () => {
    // clean input value
    setCriteria("");
    // hide clear button
    setShowClearBtn(false);
    // set loading state
    setLoading(false);
    dirty.current = false;
    props.handleChange(
      props.index,
      "bowlingCenterName"
    )({ target: { value: "" } });
    props.handleChange(props.index, "uuid")({ target: { value: null } });
  };

  const selectBowlingCenter = (bowlingCenter) => {
    setCriteria(bowlingCenter.companyName);
    props.handleChange(
      props.index,
      "bowlingCenterName"
    )({ target: { value: bowlingCenter.companyName } });
    props.handleChange(
      props.index,
      "uuid"
    )({ target: { value: bowlingCenter.uuid } });
    dirty.current = false;
    setShowClearBtn(false);
  };

  return (
    <div className={styles.bowlingList}>
      <div className={`${styles.searchInput}`}>
        {/*<span className={styles.searchIco}>
          <img src={glass} alt="Magnify glass" />
  </span>*/}
        <input
          type="text"
          value={criteria}
          onChange={handleOnChange}
          /* onFocus={() => setOnFocus(true)}
            onBlur={() => setOnFocus(false)}*/
        />
        {showClearBtn && (
          <button className={styles.searchClear} onClick={handleClear}>
            <img src={clear} alt="close icon" />
          </button>
        )}
      </div>
      {dirty.current && (
        <div className={styles.containerScroll}>
          <ul className={styles.bowlingCenters}>
            {isLoading ? (
              <div className={styles.loadingList}>
                <div />
                <div />
                <div />
              </div>
            ) : bowlingcentersFiltered.length > 0 ? (
              bowlingcentersFiltered &&
              bowlingcentersFiltered.map((bowlingCenter, i) => (
                <li
                  key={`${bowlingCenter.id} ${i}`}
                  onClick={() => selectBowlingCenter(bowlingCenter)}
                >
                  {bowlingCenter.companyName}
                  <span
                    style={{ fontSize: "10px", textAlign: "end" }}
                  >{`${bowlingCenter.location}, ${bowlingCenter.country}`}</span>
                </li>
              ))
            ) : (
              <div className={styles.noAvailableBC}>
                <span
                  style={{ color: "#D60D51" }}
                >{`No exact bowling center for "${criteria}"`}</span>
                <span
                  style={{
                    fontFamily: "SF Pro Text Regular",
                    marginTop: "12px",
                    fontSize: "12px",
                  }}
                >
                  {
                    "You may want to try using different keyword or checking for typos"
                  }
                </span>
              </div>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};
export default SearchBC;
